<img src="../../../assets/images/risk_action.png" />
